import './PlayNextList.css';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useFilteredPrioritizedGames } from '../../../../../../shared/src/hooks/use-filtered-prioritized-games.hook';
import { useTranslations } from '../../../../../../shared/src/hooks/use-translations.hook';
import { useActiveStateWithTimeoutHook } from '../../../../../../shared/src/hooks/use-active-state-with-timeout.hook';
import { SessionEndConfirmPopup } from '../../../../../../shared/src/components/SessionEndConfirmPopup';
import { PlayNextItem } from '../PlayNextItem';
import { useRealScreenSize } from '../../../../../../shared/src/hooks/use-real-screen-size.hook';
import { useNeoCmsFeatureRelatedGamesHook } from '../../../../../../shared/src/hooks/use-neo-cms-feature-related-games.hook';
import { NeoCmsGameCategoryFeatureNamesEnum } from '../../../../../../shared/src/enums/neo-cms-game-category-feature-names.enum';
import { useDeviceTypeHook } from '../../../../../../shared/src/hooks/use-device-type.hook';
import { exactDeviceTypesEnum } from '../../../../../../shared/src/enums/device-types.enum';

export const PlayNextList = ({
    amountOfGamesToShow = 7,
    onCloseGamesList = () => { },
    cancelScheduledClose = () => { }
}) => {
    const { t } = useTranslations();
    const { isNeoCmsIntegrationEnabled } = useSelector((state) => (state.app));
    const { gamesById } = useSelector((state) => (state.casino));
    const { isMobile, exactType, isFinePointer } = useDeviceTypeHook();
    let { presentPrioritizedGamesOnBrand } = useFilteredPrioritizedGames();
    const featureName = NeoCmsGameCategoryFeatureNamesEnum.PLAY_NEXT_IN_GAME_PAGE;
    const { featureRelatedGames } = useNeoCmsFeatureRelatedGamesHook(featureName);
    const [confirmPopupGame, setConfirmPopupGame] = useState(null);
    const {
        isActive: popupActive,
        deactivate: closePopup,
        activate: activatePopup,
    } = useActiveStateWithTimeoutHook({
        timeoutMs: 7_000,
    });
    const { isPortrait } = useRealScreenSize();

    if (isNeoCmsIntegrationEnabled) {
        presentPrioritizedGamesOnBrand = featureRelatedGames.map(game => game.id);
    }

    if (!gamesById) {
        return null;
    }

    const activateConfirmPopup = (game) => {
        setConfirmPopupGame(game);
        activatePopup();
    };

    const switchGameStateHandler = () => {
        closePopup();
        setConfirmPopupGame(null);
        onCloseGamesList();
    };

    const listContent = presentPrioritizedGamesOnBrand.slice(0, amountOfGamesToShow).map((gameId) => {
        const game = gamesById[gameId];

        return (
            <PlayNextItem
                key={gameId}
                game={game}
                onClickHandler={() => {
                    activateConfirmPopup(game);
                }}
            />
        );
    });

    const fromTinyDesktopStyles = exactType === exactDeviceTypesEnum.TINY_DESKTOP ||
        !isMobile;

    const wrapperClass = classNames(
        'game-page-header-play-next-list',
        {
            'game-page-header-play-next-list--from-tiny-desktop': fromTinyDesktopStyles,
        }
    );

    const itemsClass = classNames(
        'game-page-header-play-next-list__items',
        {
            'game-page-header-play-next-list__items--slider': !isFinePointer,
            'game-page-header-play-next-list__items--row': isFinePointer,
            'game-page-header-play-next-list__items--desktop': !isMobile,
        }
    );

    const gradientClass = classNames(
        'game-page-header-play-next-list__gradient',
        {
            'game-page-header-play-next-list__gradient--from-tiny-desktop': fromTinyDesktopStyles,
        }
    );

    const playNextConfirmClass = classNames(
        'game-page-header-play-next-confirm',
        {
            'game-page-header-play-next-confirm--desktop': !isMobile,
        }
    );

    return (
        <>
            <div className={wrapperClass}>
                <div className="game-page-header-play-next-list__title"
                    onMouseLeave={isFinePointer ? onCloseGamesList : null}
                >
                    {t('playNext')}
                </div>

                <div className={itemsClass}
                    onMouseEnter={isFinePointer ? cancelScheduledClose : null}
                    onMouseLeave={isFinePointer ? onCloseGamesList : null}
                >
                    {isFinePointer && listContent}
                    {!isFinePointer && <Swiper
                        slidesPerView={'auto'}
                        effect={'slide'}
                        loop={false}
                        autoplay={false}
                        spaceBetween={8}
                        direction={isPortrait ? 'horizontal' : 'vertical'}
                    >
                        {listContent.map((item, index) => <SwiperSlide
                            key={index}
                        >
                            {item}
                        </SwiperSlide>)}
                    </Swiper>}
                </div>
            </div>

            <div className={gradientClass} />

            {popupActive && confirmPopupGame && <>
                <SessionEndConfirmPopup
                    className={playNextConfirmClass}
                    gameId={confirmPopupGame.id}
                    gameName={confirmPopupGame.name}
                    onConfirmClickHandler={switchGameStateHandler}
                    cancelScheduledClose={cancelScheduledClose}
                    closeGamesList={onCloseGamesList}
                />
                <div
                    className="game-page-header-play-next-confirm-overlay"
                    onClick={closePopup}
                />
            </>}
        </>
    );
};
